import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import InputMask from 'react-input-mask';
import getLocale from '../../../i18n/getLocale';


class ScheduleUsedRegimeEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      id: this.props.id,
      schedule: this.props.schedule,
      start_day: this.props.start_day,
    };
    this.editScheduleUsedRegime = this.editScheduleUsedRegime.bind(this);
    this.deleteScheduleUsedRegime = this.deleteScheduleUsedRegime.bind(this);

    this.locale = getLocale();
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0) {
        this.setState({id: newProps.id});
        this.setState({schedule_regime: newProps.schedule_regime});
        this.setState({start_day: newProps.start_day});
        this.setState({loaded: 1});
    }
  }

  editScheduleUsedRegime(id) {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: id,
      start_day: this.state.start_day,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/regimes/editar', { method: 'put', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        self.setState({start_day: responseJson.data.start_day_str});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteScheduleUsedRegime (schedule_used_regime_id) {
    var confirm = window.confirm(this.locale.Escalas.EditarEscalaCVODVO.tabelaRegimesEmUso.deletarRegime);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/uso/regime/' + schedule_used_regime_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          if (responseJson.status === 'success') {
            self.props.refreshScheduleRegimes(responseJson);
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    var self = this;
    var key_control = 0;
    return (
<tr>
    <td>
    <RequestApi ref={'request_api'} />
        {self.state.id}
    </td>
    <td>
        {self.state.schedule_regime}
    </td>
    <td>
        <InputMask value={this.state.start_day} maskChar={null} name="start_day" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'start_day')} placeholder="" />
    </td>
    <td>

        <div className="btn-group">
            <button className="btn btn-sm btn-primary" onClick={() => {self.editScheduleUsedRegime(self.state.id)}}>
                <i className="fa fa-fw fa-pencil"></i>
            </button>
            <button className="btn btn-sm btn-danger" onClick={() => {self.deleteScheduleUsedRegime(self.state.id)}}>
              <i className="fa fa-fw fa-trash"></i>
            </button>
        </div>
    </td>
</tr>
    );
  }
}

export default ScheduleUsedRegimeEdit;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/ScheduleUsedRegimeEdit.js